/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { FormattedMessage } from 'react-intl';
import { SeparatorCircleIcon } from '~design-system';
import { PullRequest } from '~shared/types/branch-like';
import { MeasureEnhanced } from '~shared/types/measures';
import { MetricKey, MetricType } from '~shared/types/metrics';
import { getLeakValue } from '~sq-server-commons/components/measure/utils';
import LastAnalysisLabel from '~sq-server-commons/components/overview/LastAnalysisLabel';
import { findMeasure } from '~sq-server-commons/helpers/measures';
import { formatMeasure } from '~sq-server-commons/sonar-aligned/helpers/measures';
import { CurrentBranchLikeMergeInformation } from '../../nav/component/branch-like/CurrentBranchLikeMergeInformation';

interface Props {
  measures: MeasureEnhanced[];
  pullRequest: PullRequest;
}

export function PullRequestMetaContentHeader({ measures, pullRequest }: Readonly<Props>) {
  return (
    <>
      {pullRequest?.analysisDate && (
        <>
          <LastAnalysisLabel analysisDate={pullRequest.analysisDate} />
          <SeparatorCircleIcon />
        </>
      )}
      <span>
        {formatMeasure(
          getLeakValue(findMeasure(measures, MetricKey.new_lines)),
          MetricType.ShortInteger,
        ) || '0'}{' '}
        <FormattedMessage id="metric.new_lines.name" />
      </span>
      <SeparatorCircleIcon />
      <CurrentBranchLikeMergeInformation pullRequest={pullRequest} />
    </>
  );
}
